import Link from "./Link";
import { isLink, RenderLink } from "./RenderLink";
export default Link;
export {
    RenderLink,
    isLink,
    Link
};
